import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c16aa24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-section" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    src: "/assets/img/logo-large.svg"
  })
], -1))
const _hoisted_3 = {
  key: 0,
  class: "login-demo-text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "下のログインボタンを押してください。", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "実際の試験では受検番号とパスワードを入力していただきます。", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "site-info"
}
const _hoisted_8 = { class: "site-code" }
const _hoisted_9 = { class: "site-name" }
const _hoisted_10 = {
  key: 2,
  autocomplete: "off"
}
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["onKeyup", "disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1))
const _hoisted_15 = [
  _hoisted_14
]

import {ref, inject} from "vue"
import { useRoute, useRouter } from 'vue-router'
import { examKey } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  emits: ['overridePageName'],
  setup(__props) {

const exam = inject(examKey);


const route = useRoute();
const router = useRouter();

const error = ref('');
const examinee = ref('');
const password = ref('');
const group = route.params.group;

const invalidUrl = ref(false);
const gakken = exam?.isGakken();
const demo = exam?.isDemo();
const official = exam?.isOfficial();

const siteCode = ref('');
const siteName = ref('');

const login = async () => {
  if (!exam) return;
  try {
    await exam.logout();
    if (demo) {
      await exam.demoLogin('2');
    } else {
      await exam.login(examinee.value, password.value, typeof group === 'string' ? group : group[0]);
    }
    exam.startFullScreen();
    await router.replace(`/cbt/${group}/start`);
  }
  catch(e) {
    error.value = e.message;
    password.value = '';
  }
}

const init = async () => {
  if (!exam) return;
  if (exam.isGakken()) {
    await exam.logout();
    const token = window.location.hash.substring(1);
    if (token) {
      await exam.gakkenLogin(token);
      router.replace(`/cbt/${group}/start`);
    }
  }
  if (exam.isOfficial()) {
    try {
      const site = await exam.siteInfo(`${group}`);
      if (site.code == null) {
        invalidUrl.value = true;
        return;
      }
      siteCode.value = site.code;
      siteName.value = site.name;
    } catch (e) {
      invalidUrl.value = true;
    }
  }
}
init();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(demo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
      : _createCommentVNode("", true),
    (_unref(official))
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(siteCode.value), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(siteName.value), 1)
        ]))
      : _createCommentVNode("", true),
    (!_unref(gakken) && !invalidUrl.value)
      ? (_openBlock(), _createElementBlock("form", _hoisted_10, [
          (error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            autocomplete: "off",
            class: "m-input__text login-id",
            placeholder: "じゅけんばんごう",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((examinee).value = $event)),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$refs.inputPassword.focus()), ["enter"])),
            disabled: _unref(demo)
          }, null, 40, _hoisted_12), [
            [_vModelText, examinee.value]
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            autocomplete: "off",
            class: "m-input__text login-pw",
            placeholder: "パスワード",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            ref: "inputPassword",
            onKeyup: _withKeys(login, ["enter"]),
            disabled: _unref(demo)
          }, null, 40, _hoisted_13), [
            [_vModelText, password.value]
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "m-btn primary is-center",
            onClick: login
          }, _hoisted_15)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})